var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ModalCore, } from '@core-front/modal';
import BodyScroll from '@telia-front/body-scroll';
import CloseButton from '@telia-front/close-button';
import PageAccess from '@telia-front/page-access';
import VisibilityProvider from '@telia-front/visibility-provider';
import ModalCover from '../modal-cover/modal-cover';
import ModalHeader from '../modal-header/modal-header';
const Modal = (props) => {
    const { cover, className, closeButtonTheme, isHeaderSticky } = props, rest = __rest(props, ["cover", "className", "closeButtonTheme", "isHeaderSticky"]);
    const BEM = () => {
        const classArray = [];
        if (cover) {
            classArray.push('modal--cover');
        }
        if (className) {
            classArray.push(className);
        }
        if (isHeaderSticky) {
            classArray.push('modal--with-sticky-header');
        }
        return classArray.join(' ');
    };
    const renderCover = (cover) => {
        if (!cover) {
            return;
        }
        return (React.createElement(ModalCover, Object.assign({}, cover)));
    };
    return (React.createElement(ModalCore, Object.assign({}, rest, { asideContent: renderCover(cover), className: BEM(), components: {
            BodyScroll,
            CloseButton: (props) => (React.createElement(CloseButton, Object.assign({}, props, { theme: closeButtonTheme === 'light' ? 'dark' : 'light', type: "modal" }))),
            PageAccess,
            VisibilityProvider,
        }, headerType: ModalHeader })));
};
export { Modal as default, };
